import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <span className="warning-icon">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M8 1L14 14H2L8 1Z"
                            fill="#FF0000"
                            stroke="#FF0000"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M8 5V9"
                            stroke="#FFFFFF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <circle cx="8" cy="11.5" r="1" fill="#FFFFFF" />
                    </svg>
                </span>
                <p>
                    <strong>Disclaimer:</strong> This page is not an official OSAP page. The information provided here is for general guidance only and does not constitute official advice from the Ontario Student Assistance Program (OSAP). For official information, please visit the <a href="https://www.ontario.ca/page/osap-ontario-student-assistance-program" target="_blank" rel="noopener noreferrer">official OSAP website</a>.
                </p>
            </div>
        </footer>
    );
}

export default Footer;